<div class="se-side-image-preview-items-container">
    <ng-container *ngIf="!!keyImages.length; else keyImagesNoResult">

        <div class="se-draggable-list-2">
            <div class="se-draggable-img-preview-2" *ngFor="let item of keyImages">
                <se-side-key-images-item (updateStateEvent)="updateState($event)" (deleteImageEvent)="showModal($event)" [keyImageObject]="item"></se-side-key-images-item>
            </div>
        </div>

    </ng-container>

    <div class="estensa-spinner" *ngIf="isLoading | async">
        <mat-spinner></mat-spinner>
    </div>
    <ng-template #keyImagesNoResult>
        <div class="se-side-key-images-text-container">
            <span>{{sideKeyImagesMessage}}</span>
        </div>
    </ng-template>
</div>

<div class="se-side-key-toolbar-container">
    <mat-form-field style="padding: 10px 5px 10px 15px; min-width: 115px; max-width: 120px;"
                    appearance="outline">
        <mat-label matTooltip="{{ 'ImageKey_ImageRowCount' | translate }}">{{ 'ImageKey_ImageRowCount' | translate }}</mat-label>
        <mat-select placeholder="{{ 'ImageKey_ImageRowCount' | translate }}"
                    [disabled]="!!!keyImages.length"
                    [(value)]="layoutNumber"
                    (selectionChange)="selectRow(layoutNumber)"
                    matTooltip="{{ 'ImageKey_ImageRowCountDetails' | translate }}"
                    matTooltipShowDelay='500'>
            <mat-option *ngFor="let item of [1, 2, 3, 4, 5]" [value]="item">
                {{ item }}

            </mat-option>
        </mat-select>
    </mat-form-field>

    <div style="display: flex; flex: 1; align-items: center;">
        <button mat-button
                class="search-panel-button"
                [disabled]="!!!keyImages.length"
                style="flex:1"
                id="fab-grid-config"
                type="button"
                (click)="deleteImagesFromRepository()"
                matTooltip="{{ 'ImageKey_DeleteAllDetails' | translate }}"
                matTooltipShowDelay='500'>
            {{ 'ImageKey_DeleteAll' | translate }}
        </button>
    </div>
</div>



